

































































































































































































































































































































































import { Component, Mixins, Prop, Emit, Watch } from 'vue-property-decorator';
import { State, Mutation, Action } from 'vuex-class';
import _omit from 'lodash.omit';
import {
  TextOutput,
  ExternalWallet,
  AuthQuery,
  TransactionFees,
} from '~/mixins';
import TransactionFeeSelector from '~/components/Wallet/TransactionFeeSelector.vue';
import RequirePasscode from '~/components/Wallet/RequirePasscode.vue';
import InsufficientFunds from '~/components/Wallet/InsufficientFunds.vue';
import GiveAllowance from '~/components/Wallet/GiveAllowance.vue';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import { IWallet } from '~/store/inventory/types';
import { ICurrentPage } from '~/store/types';
import LegalAgreements from '~/components/LegalAgreements/LegalAgreements.vue';
import { checkForSufficientErc20Allowance } from '~/utils';
import { FiatProvider } from '../../types/fiat-provider';
import {
  IGameItemForSaleByGala,
  IGameItemProductPrice,
  ITokenClassKey,
} from '../../store/games/types';
import Stripe from '../../mixins/Stripe';
import { StripeElements } from '@stripe/stripe-js';
import { IUser } from '../../store/profile/types';
import CoinflowPurchase from '../Coinflow/CoinflowPurchase.vue';
import CoinflowCardNumberInput from '../Coinflow/card-form/CoinflowCardNumberInput.vue';
import CoinflowCvvInput from '../Coinflow/card-form/CoinflowCvvInput.vue';
import Coinflow from '../Coinflow/Coinflow.vue';
import {
  GalaChainMethods,
  ITokenInsanceKeyWithQuantity,
} from '~/types/gala-chain';
import AllowanceModal from '~/components/UIComponents/AllowanceModal.vue';
import { IAllowancePromptConfig } from '~/types/allowances';
import { createGalaSwapAllowancePrompt } from '~/data/allowance_prompts';
import SweepstakesCallout from '../UIComponents/SweepstakesCallout.vue';

@Component({
  components: {
    LegalAgreements,
    TransactionFeeSelector,
    RequirePasscode,
    InsufficientFunds,
    FullScreenDialog,
    GiveAllowance,
    CoinflowPurchase,
    CoinflowCardNumberInput,
    CoinflowCvvInput,
    Coinflow,
    AllowanceModal,
    SweepstakesCallout,
  },
})
export default class Confirm extends Mixins(
  TextOutput,
  ExternalWallet,
  Stripe,
  AuthQuery,
  TransactionFees,
) {
  @State(profile => profile.user.hasGyriPassphrase, { namespace: 'profile' })
  hasGyriPassphrase!: boolean;

  @Prop(String) readonly imageUrl!: string;
  @Prop(Object) readonly product!: IGameItemForSaleByGala;
  @Prop(Number) readonly quantity!: number;
  @Prop(String) readonly orderId!: string;
  @Prop(String) readonly purchaseCurrency!: string;
  @Prop(String) readonly transactionType!: string;
  @Prop(String) readonly galachainInvoiceAccountKey!: string;
  @Prop(Number) readonly subtotal!: number;
  @Prop(String) readonly selectedCredit!: FiatProvider;
  @Prop({ type: Boolean, default: true }) readonly displayQuantity!: boolean;
  @Prop(Function) readonly buy!: (
    passcode: string,
    transactionFee: number,
  ) => Promise<
    { success: boolean; results?: any; message?: string } | { data: any }
  >;
  @Prop(Function) readonly orderWithW3w!: (transactionFee: number) => void;
  @Prop(Function) readonly orderWithStripe!: (
    stripeElement: StripeElements,
  ) => void;
  @Prop(Function) readonly orderWithCoinflow!: (conflowRef: Coinflow) => void;
  @Prop(String) readonly customPurchaseLoadingVideoUrl?: string;
  @Prop(Function) readonly backToItem!: Function;
  @Prop(Number) selectedPriceRebateInUsd!: number;
  @Prop(Object) selectedPrice!: IGameItemProductPrice & { imageUrl?: string };
  @Prop(String) galaTagName!: string;
  @Prop(Boolean) isGalaTagToken!: boolean;
  @State(profile => profile.user, { namespace: 'profile' })
  user!: IUser;

  @Action('getNewNotifications', { namespace: 'notifications' })
  getNewNotifications!: () => void;

  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  @Action('promptToRegister')
  private promptToRegister!: (options?: {
    redirectAfterLoginPath?: string;
  }) => void;

  orderButtonDisabled: boolean = false;
  agreements: boolean = false;
  orderInFlight = false;
  passcodePrompt = false;
  insufficientBalanceDialog = false;
  showAllowancePrompt = false;
  hideFee = false;
  insufficientFundsWallets: IWallet[] | [] = [];
  allowancePromptConfig: IAllowancePromptConfig | null = null;

  gcTempTransferCode = 'galachain';
  tempTransferCodeHeading = 'Please enter the temporary transfer code ';
  w3wConnectionEnabled = process.env.w3wConnectionEnabled;
  orderPaymentContractAddress = process.env.orderPaymentContractAddress;
  stripeElement: StripeElements | null = null;
  stripeStyle: object = {
    position: 'fixed',
    top: '-10000px',
  };
  phantomNodeLegalAgreements = {
    purchaseAgreementCheckbox: {
      text: this.$t('components.store.confirm.phantomNodeNonInvestment'),
    },
    additionalTermsOfService: {
      text: this.$t('components.store.confirm.phantomNodeTerms'),
      href: 'https://phantomarena.co/#/IntoNode',
    },
  };

  get isCreditCard() {
    return this.purchaseCurrency.startsWith('CC') && this.selectedCredit;
  }

  get selectedPriceRebateToken() {
    return this.selectedPrice?.rebate?.tokenClassKey?.collection;
  }

  get isPhantomArenaNft() {
    return this.product?.baseId === 'PhantomArenaNodesINTONodeEpic';
  }

  get showGalaLiabilityDisclaimer() {
    return this.product?.baseId === 'PhantomArenaNodesINTONodeEpic';
  }

  get paymentCurrencyWallet() {
    return this.neededWallets.find(
      wallet => wallet.symbol === this.formattedPurchaseCurrency,
    );
  }

  get hasFees() {
    return !this.isCreditCard;
  }

  get showSweepstakes() {
    return (
      this.selectedPrice.symbol === 'GALA[GYRI]' &&
      this.selectedPrice.transactionType === 'burn'
    );
  }

  async mounted() {
    if (this.selectedCredit === FiatProvider.STRIPE) {
      this.stripeStyle = {};
      await this.createStripeElement();
    }

    if (this.hasFees) {
      if (this.isGalachain) {
        const qualifies = this.checkIfUserMeetsRequirements();

        if (!qualifies) {
          this.hideFee = true;
          return;
        }

        this.transactionFeeCurrency = 'GALA[GYRI]';
        const feeCode =
          this.transactionType === 'burn'
            ? GalaChainMethods.BurnTokens
            : GalaChainMethods.TransferToken;
        const symbolMatch = this.paymentCurrencyWallet.symbol.match(
          /^(\w*)\[\w*\]$/,
        );
        const tokenClassKey = (this.paymentCurrencyWallet
          .tokenClassKey as ITokenClassKey) || {
          collection: symbolMatch ? symbolMatch[1] : '',
          category: 'Unit',
          type: 'none',
          additionalKey: 'none',
        };

        const cost = this.subtotal;

        const transactionData: Array<{
          method: GalaChainMethods;
          tokenInstances: ITokenInsanceKeyWithQuantity[];
          target?: string;
        }> = [
          {
            method: feeCode,
            tokenInstances: [
              {
                quantity: cost.toString(),
                tokenInstanceKey: {
                  ..._omit(tokenClassKey, '__typename'),
                  instance: '0',
                },
              },
            ],
            target:
              this.galachainInvoiceAccountKey === 'GC_ADMIN' ||
              !this.galachainInvoiceAccountKey
                ? 'client|ops-admin'
                : this.galachainInvoiceAccountKey,
          },
        ];

        if (this.transactionType === 'split') {
          // Calculate 30% of the payment total and round it to 8 decimal places
          const burnAmount = (cost * 0.3).toFixed(8);
          // Calculate 70% of the payment total and round it to 8 decimal places
          const sendAmount = (cost * 0.7).toFixed(8);

          transactionData[0].tokenInstances[0].quantity = sendAmount;

          transactionData.push({
            method: GalaChainMethods.BurnTokens,
            tokenInstances: [
              {
                quantity: burnAmount,
                tokenInstanceKey: {
                  ..._omit(tokenClassKey, '__typename'),
                  instance: '0',
                },
              },
            ],
          });
        }

        this.getGalachainTransactionFeeEstimate(transactionData);
      } else {
        this.getTransactionFeeEstimate(this.transactionFeeEstimateSymbol);
      }
    }
  }

  report() {
    console.log(
      this.selectedCredit,
      this.purchaseCurrency,
      this.transactionFeeCurrency,
    );
  }

  toggleAgreement(payload: any) {
    this.agreements = payload.allAccepted;
  }

  toggleOrderButtonDisable(disable: boolean) {
    this.orderButtonDisabled = disable;
  }

  get requiresGyriPasscode() {
    return this.isGalachain;
  }

  get isMissingGyriPassphrase() {
    if (this.requiresGyriPasscode && !this.hasGyriPassphrase) {
      return true;
    }
    return false;
  }

  get missingWallet() {
    if (this.isMissingGyriPassphrase) {
      return 'gyri';
    } else if (
      !this.requiresGyriPasscode &&
      !this.walletExists &&
      !this.w3wConnectionActive
    ) {
      return 'eth';
    }
    return '';
  }

  get isGalachain() {
    const wallet = this.userWallets.find(
      w => w.symbol.toLowerCase() === this.purchaseCurrency.toLowerCase(),
    );

    if (wallet) {
      return (
        wallet.network.toLowerCase() === 'gyri' ||
        wallet.network.toLowerCase() === 'galachain'
      );
    }

    return (
      this.purchaseCurrency.includes('[GC]') ||
      this.purchaseCurrency.includes('[GYRI]')
    );
  }

  get total() {
    if (this.purchaseCurrency === this.transactionFeeCurrency) {
      return this.subtotal + this.transactionFee;
    }

    return this.subtotal;
  }

  // formats payment currency with [GYRI] or [ETH] when needed to match wallet.symbol
  get formattedPurchaseCurrency() {
    // GalaChain currencies are always appended with [GYRI]
    if (this.isGalachain) {
      return this.purchaseCurrency;
    }

    // Check if wallets require [ETH] appended or not
    const matchingWallets = this.userWallets.filter(w =>
      w.symbol.toLowerCase().includes(this.purchaseCurrency.toLowerCase()),
    );
    const includesWalletsAppendedWithETH = matchingWallets.some(w =>
      w.symbol.endsWith('[ETH]'),
    );

    return includesWalletsAppendedWithETH
      ? `${this.purchaseCurrency}[ETH]`
      : this.purchaseCurrency;
  }

  get coinIcons() {
    const coins: { baseCurrency: string; feeCurrency?: string } = {
      baseCurrency: `https://static.gala.games/token-icons/${this.purchaseCurrency.replace(
        /\[ETH\]|\[GC\]|-(.*)/g,
        '',
      )}-icon.png`,
    };

    if (
      this.transactionFeeCurrency &&
      this.purchaseCurrency !== this.transactionFeeCurrency
    ) {
      coins.feeCurrency = `https://static.gala.games/token-icons/${this.transactionFeeCurrency.replace(
        /\[ETH\]|\[GC\]/g,
        '',
      )}-icon.png`;
    }

    return coins;
  }

  updateFee(fee: number) {
    this.selectedFee = fee;
  }

  get neededWallets() {
    return this.userWallets
      ? this.userWallets.reduce((accumulator: any[], wallet: any) => {
          if (
            wallet.symbol === this.formattedPurchaseCurrency ||
            wallet.symbol === this.transactionFeeCurrency
          ) {
            const lesserBalance = Math.min(
              +wallet.balance.confirmed,
              +wallet.balance.unconfirmed,
            );

            const totalPurchaseCurrencyNeeded =
              this.formattedPurchaseCurrency === this.transactionFeeCurrency
                ? this.total + this.transactionFee
                : this.total;

            const sufficient =
              wallet.symbol === this.formattedPurchaseCurrency
                ? lesserBalance >= totalPurchaseCurrencyNeeded
                : lesserBalance >= this.transactionFee;

            accumulator.push({
              ...wallet,
              availableBalance: lesserBalance,
              sufficient,
            });
          }
          return accumulator;
        }, [])
      : [];
  }

  get transactionFeeEstimateSymbol() {
    if (this.w3wConnectionEnabled) {
      if (this.transactionType === 'burn') {
        return 'ORDER_PAYMENT_BURN_ERC20';
      } else if (this.purchaseCurrency === 'ETH') {
        return 'ORDER_PAYMENT_TRANSFER_ETH';
      } else if (this.formattedPurchaseCurrency.includes('[ETH]')) {
        return 'ORDER_PAYMENT_TRANSFER_ERC20';
      }

      return this.purchaseCurrency;
    }
    return this.purchaseCurrency;
  }

  checkForSufficientFunds() {
    if (this.neededWallets.length) {
      const insufficientFundsWallets = this.neededWallets.filter(
        wallet => !wallet.sufficient,
      );
      if (insufficientFundsWallets.length) {
        this.insufficientFundsWallets = insufficientFundsWallets;
        this.insufficientBalanceDialog = true;

        return false;
      }
      return true;
    }
    return false;
  }

  checkIfUserMeetsRequirements() {
    if (!this.user.loggedIn) {
      this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
      return;
    }

    if (this.missingWallet) {
      this.toggleCreateWalletPrompt({
        show: true,
        walletType: this.missingWallet,
      });
      return;
    }

    if (!this.checkForSufficientFunds()) {
      return;
    }

    return true;
  }

  async onGrantAllowanceSuccess(results: { transferCode: string }) {
    const orderResults = await this.placeOrder({
      allowancesGranted: true,
      transferCode: results.transferCode,
    });

    if (orderResults && 'data' in orderResults) {
      const buyResult = await this.onBuyComplete({
        success: true,
        results: orderResults.data,
      });
      this.allowancePromptConfig = null;
      return buyResult;
    }

    this.allowancePromptConfig = null;
  }

  async placeOrder(
    state: {
      allowancesGranted?: boolean;
      transferCode?: string;
    } = {},
  ) {
    if (!state.allowancesGranted) {
      const rebate = this.selectedPrice.rebate;
      if (rebate) {
        const needsSwapAllowance = rebate.type === 'gala-autoswap';

        if (needsSwapAllowance) {
          this.allowancePromptConfig = createGalaSwapAllowancePrompt(
            rebate.tokenClassKey,
          );

          return;
        }
      }
    }

    if (this.selectedCredit === FiatProvider.STRIPE && this.stripeElement) {
      this.orderInFlight = true;
      await this.orderWithStripe(this.stripeElement);
      this.orderInFlight = false;
    } else if (
      this.selectedCredit === FiatProvider.COINFLOW &&
      this.$refs.coinflow
    ) {
      this.orderInFlight = true;
      await this.orderWithCoinflow(this.$refs.coinflow as Coinflow);
      this.orderInFlight = false;
    } else {
      return this.promptForWalletPassword(state.transferCode);
    }
  }

  async promptForWalletPassword(walletPassword: string | undefined) {
    if (this.selectedCredit) {
      return;
    }
    if (!this.isGalachain) {
      const success = await this.establishWalletConnection();
      if (!success) return;
    }

    const qualifies = this.checkIfUserMeetsRequirements();
    if (!qualifies) {
      return;
    }

    if (this.walletConnected && !this.requiresGyriPasscode) {
      const enabled = this.checkW3wConnectionEnabled();
      if (!enabled || this.orderInFlight) {
        return;
      }

      if (!this.w3wConnectionActive) {
        this.toggleCreateWalletPrompt({ show: true, walletType: 'eth' });
        return;
      }

      if (
        this.purchaseCurrency.toLowerCase() !== 'eth' &&
        process.env.orderPaymentContractAddress
      ) {
        const sufficientAllowance = await checkForSufficientErc20Allowance({
          owner: this.externalWalletAddress,
          spender: process.env.orderPaymentContractAddress,
          contractAddress: this.paymentCurrencyWallet.contractAddress,
          neededAmount: this.subtotal,
          web3Provider: this.web3Provider,
        });
        if (!sufficientAllowance) {
          this.showAllowancePrompt = true;
          return;
        }
      }
      this.orderInFlight = true;
      await this.orderWithW3w(this.selectedFee);
      this.orderInFlight = false;
    }

    // If we're here then we need transfer code.

    if (walletPassword) {
      // Already have transfer code, don't need to ask for it again
      return this.handleBuy(walletPassword);
    } else {
      // Need to ask for transfer code
      this.passcodePrompt = true;
    }
  }

  async handleSuccessfulAllowance() {
    this.orderInFlight = true;
    this.showAllowancePrompt = false;
    await this.orderWithW3w(this.selectedFee);
    this.orderInFlight = false;
  }

  handleBuy(passcode: string) {
    return this.buy(passcode, this.selectedFee);
  }

  matchInstructions(input: string) {
    return (
      input === this.gcTempTransferCode ||
      `Input must match "${this.gcTempTransferCode}" per the instructions above.`
    );
  }

  checkW3wConnectionEnabled() {
    if (this.w3wConnectionEnabled) {
      return true;
    }

    const errorMsg =
      'External Web3 wallet functionality is currently unavailable';

    this.updateSnackbarErrorText(errorMsg);
    this.toggleErrorSnackbar();

    return false;
  }

  async createStripeElement() {
    this.stripeElement = await this.stripeMixinCreateStripeElement(
      '#stripe-elements-host',
      parseInt((this.subtotal * 10 ** 2).toFixed(0)),
      {
        billingDetails: {
          email: this.user.email,
          phone: this.user.phone,
        },
      },
    );
  }

  @Emit('purchase-complete')
  onBuyComplete(res: { success: boolean; message?: string; results?: any }) {
    this.passcodePrompt = false;
    return res;
  }

  @Watch('transactionFee')
  emitTansactionFee(transactionFee: number) {
    this.$emit('transaction-fee', {
      transactionFee,
      currency: this.transactionFeeCurrency,
    });
  }

  @Watch('selectedCredit')
  async handleCreditCardSelection(selectedCredit: FiatProvider) {
    if (selectedCredit === FiatProvider.STRIPE) {
      this.stripeStyle = {};
      await this.createStripeElement();
    } else if (this.stripeElement) {
      this.stripeStyle = {
        position: 'fixed',
        top: '-10000px',
      };
      this.stripeMixinDestroyStripeElement(this.stripeElement);
      this.stripeElement = null;
    }
  }
}
